import { Modal } from 'antd'
import { OnboardingTypeEnum } from 'hooks/useRiseUpAPIV1'
import { InvestingPersonEnum } from 'interfaces'
import React from 'react'
import { isDesktop, isMobile, isTablet } from 'react-device-detect'
import { IconContext } from 'react-icons'
import { AiOutlineInfoCircle } from 'react-icons/ai'
import { getOnboardingType } from 'utils'
import Button from '../Button'

interface ProceedModalProps {
  isVisible: boolean
  onProceed: () => void
  onCancel: () => void
  data: any
}

const InvestorUnauthorizedModal = ({ isVisible, onProceed, onCancel, data }: ProceedModalProps) => {
  const type = getOnboardingType(
    data.investingProfile.option !== InvestingPersonEnum.RETIREMENT
      ? data.investingProfile.option
      : data.investingProfile.retirementAccountType,
  )

  return (
    <>
      <Modal
        width={`${(isMobile || isTablet) && !isDesktop ? '90vw' : '50vw'}`}
        open={isVisible}
        centered
        footer={null}
        closable={false}
      >
        <div className="flex flex-col items-center">
          <div className="text-5xl">
            <IconContext.Provider value={{ color: 'green' }}>
              <AiOutlineInfoCircle />
            </IconContext.Provider>
          </div>

          <div className="my-5 text-center text-xl md:text-2xl">
            {type === OnboardingTypeEnum.COMPANY &&
              'This investment will not be finalized without additional information from a person authorized by the company documents to make investment decisions for the company. You may (1) continue the application and you will be contacted later to provide additional information (2) have an authorized person fill out the forms instead of you or (3) apply to invest as an individual or jointly with another individual instead.'}
            {type === OnboardingTypeEnum.TRUST &&
              'This investment will not be finalized without additional information from a person authorized by the trust documents to make investment decisions for the trust. You may (1) continue the application and you will be contacted later to provide additional information (2) have an authorized person fill out the forms instead of you or (3) apply to invest as an individual or jointly with another individual instead.'}
            {type === OnboardingTypeEnum.IRA &&
              'This investment will not be finalized without additional information from a person authorized by the retirement account documents to make investment decisions for the retirement account. You may (1) continue the application and you will be contacted later to provide additional information (2) have an authorized person fill out the forms instead of you or (3) apply to invest as an individual or jointly with another individual instead.'}
          </div>

          <div className="flex w-full justify-center py-10 md:p-10">
            <div className="flex w-full flex-col items-center">
              <Button btnName={'Back'} btnType={'button'} onClickHandler={onCancel} />
            </div>
            <div className="flex w-full flex-col items-center">
              <Button btnName={'Proceed'} btnType={'button'} onClickHandler={onProceed} />
            </div>
          </div>
        </div>
      </Modal>
    </>
  )
}

export default InvestorUnauthorizedModal
